import $ from "jquery";
import Backbone from "backbone";

const Common = {};

Common.render_avatar = function (options) {
  var user = options.user || { avatar: false },
    avatar_class = user.avatar ? "has-avatar" : "no-avatar",
    size = options.size || "xs",
    output,
    classes = ["avatar", size, avatar_class].join(" ");

  if (options.link) {
    output = '<a href="' + options.link + '" class="' + classes + '">';
  } else {
    output = '<span class="' + classes + '">';
  }

  if (user.avatar) {
    output +=
      '<img src="' +
      user.avatar +
      '" alt="' +
      (user.full_name || "") +
      '" class="avatar-image">';
  } else {
    output +=
      '<img src="' +
      S.defaultAvatarImg +
      '" alt="' +
      (user.full_name || "") +
      '">';
  }

  if (user.link) {
    output += "</a>";
  } else {
    output += "</span>";
  }

  return output;
};

// Used to format select2 rows
Common.format_obj_label = function (obj) {
  return "<div>" + obj.label + "</div>";
};

Common.format_obj_name = function (obj) {
  return "<div>" + obj.name + "</div>";
};

Common.formatFlexSelectRow = function (row) {
  var text = row.text || row.value || "-";
  if (!row.id) {
    return '<span class="flex-dropdown-option">' + text + "</span>";
  }
  if (text.indexOf("|")) {
    var parts = text.split("|");
    return (
      '<span class="flex-dropdown-option"><strong>' +
      (parts[0] || "-") +
      "</strong>" +
      (parts[1] ? "<span>" + parts[1] + "</span>" : "") +
      "</span>"
    );
  }
  return text;
};

Common.addModal = function (data) {
  let $modal = $("#" + data.id);
  if ($modal.size()) {
    return $modal[0];
  }

  $modal = $(
    '<div id="' +
      data.id +
      '" class="modal fade" tabindex="-1" role="dialog"></div>'
  );
  var $inner = $(
    '<div class="modal-dialog" style="' +
      "width: " +
      (data.width || "95%") +
      ";" +
      "max-width: " +
      (data.maxWidth || "1400px") +
      ";" +
      '"></div>'
  );
  var $content = $('<div class="modal-content"></div>');
  $content.append(
    '<div class="modal-header inverted">' +
      '<button type="button" class="close" data-dismiss="modal">×</button>' +
      '<h3 class="modal-title">' +
      (data.title || "") +
      "</h3>" +
      "</div>"
  );
  $content.append(
    '<div class="modal-body content">' +
      '<div class="content-container">' +
      '<div class="spinner mtxl mbxl">' +
      '<div class="spinner mvl pvl">' +
      '<div class="sk-spinner sk-spinner-three-bounce">' +
      '<div class="sk-bounce1"></div>' +
      '<div class="sk-bounce2"></div>' +
      '<div class="sk-bounce3"></div>' +
      "</div>" +
      "</div>" +
      "</div>" +
      "</div>" +
      "</div>"
  );
  if (data.footer) {
    $content.append(
      '<div class="modal-footer">' +
        '<button class="btn btn-default" data-dismiss="modal" aria-hidden="true">' +
        "Stäng" +
        "</button>" +
        "</div>"
    );
  }
  $inner.append($content);
  $modal.append($inner);
  $("body").append($modal);
  return $modal;
};

Common.DynamicModalView = Backbone.View.extend({
  initialize: function () {
    this.setElement(Common.addModal(this.modalData));

    this.$el.modal({});

    this.$el.on("hide.bs.modal", () => {
      this.$el.off("hide.bs.modal");
      this.undelegateEvents();
      if (this.model && this.model.onClose) {
        this.model.onClose();
      }
    });
  },
});

export default Common;
